import { renewAccessToken, storeKey } from '@shared-core/features/auth'
import { handleErrors } from '@shared-core/features/notifications'
import { setApiErrorsHandler } from '@shared-core/runtime/api-errors'
import { setAuthRefreshHandler } from '@shared-core/runtime/auth-refresh'
import { setAuthTokenGetter } from '@shared-core/runtime/auth-token'
import { API_KNOWN_ERRORS } from '@shared-core/services/api/configs/api'
import type { AppDispatch, AppState } from '@shared-core/store/types'

export function initApiInterceptors(store: { dispatch: AppDispatch; getState: () => AppState }): void {
  setAuthTokenGetter(() => store.getState()[storeKey].accessToken)
  // Обновление токена: 401 от API → renewAccessToken → повтор запроса (см. runtime/auth-refresh).
  setAuthRefreshHandler(async () => {
    const refreshed = await store.dispatch(renewAccessToken()).unwrap()

    return refreshed
  })

  // Глобальная обработка ошибок API: подключите свой toast/шторки по мере необходимости.
  setApiErrorsHandler((response) => {
    store.dispatch(handleErrors(response, { defaultError: { error: API_KNOWN_ERRORS.SOMETHING_WENT_WRONG } }))
  })
}
